/**
 * load svg files direct
 */

import { CSSProperties, useEffect, useMemo, useState } from 'react'

type SVGProps = { file: string, style?: CSSProperties, link?: string, openNewWindow?: boolean }
type LogoIconProps = { color?: any, style?: CSSProperties, link?: string, openNewWindow?: boolean }

export function useSVGLoader(file: string) {
    const [svg, setSvg] = useState<string>('')

    // once per file, not on every draw: it was fetched again with each one
    useEffect(() => {
        let current = true
        fetch(file)
            .then((rawData) => rawData.text())
            .then((text) => {
                if (current) setSvg(text)
            })
            .catch(() => {
                // no icon is better than an error: the entry still works
            })
        return () => {
            current = false
        }
    }, [file])

    return [svg]
}

export default function SvgLoader({ file, style, link, openNewWindow }: SVGProps) {
    const [svg] = useSVGLoader(file)
    const className = link ? 'logo-link' : ''

    const handleClick = () => {
        if (!link) return
        if (openNewWindow) window.open(link, '_blank')
        else window.location.href = link
    }
    return (<i style={style} className={className} onClick={handleClick} dangerouslySetInnerHTML={{ __html: svg }}></i>)
}

export function LogoIcon({ color, style, link = '', openNewWindow = false }: LogoIconProps) {
    const logo = useMemo(() => {
        let _style = { aspectRatio: '1.5/1', maxHeight: '100%' } as CSSProperties
        if (color) _style.fill = color
        if (style) _style = { ..._style, ...style }
        return (<SvgLoader file="/images/logo-deja-converter.svg" style={_style} link={link} openNewWindow={openNewWindow} />)
    }, [color, style])
    return logo
}
